import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState } from "react";
import { AvatarFormDialog } from "./AvatarFormDialog";

export default function AddNewAvatar() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant={"ghost"}
        className={"px-2 py-1 h-auto"}
        onClick={() => setIsDialogOpen(true)}
      >
        <Plus className="h-4 w-4" />
      </Button>
      <AvatarFormDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        avatar={null}
      />
    </>
  );
}
